import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, FormControlLabel } from '@material-ui/core';

import {
  ControlledDateField,
  ControlledTagAutocomplete,
  QualificationsField,
} from '@vyce/core/src/components/controlled-inputs';
import { AppCheckbox, AppTextField } from '@vyce/core/src/components/inputs';
import { Tag } from '@vyce/core/src/types';

import { Modes, notRequiredRules, rules } from '../config';

export const NotListedIndustryQualificationForm = ({
  tags,
  isAdmin,
  setSubstring,
  editMode,
}: {
  tags: Tag[];
  isAdmin: boolean;
  setSubstring: (arg0: string) => void;
  editMode: keyof typeof Modes | null;
}) => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const notExpired = watch('not_expired');

  const handleChange = (e: any, checked: boolean) => {
    setValue('not_expired', checked);
  };

  const titleRules = useMemo(
    () =>
      editMode === Modes.create
        ? {
            required: 'This field is required',
            validate: (value: Tag | string | null) =>
              (!!value && typeof value === 'object' && !!value.uuid) ||
              'Please select a qualification from the list',
          }
        : rules,
    [editMode]
  );

  return (
    <>
      <QualificationsField name="title" label="Qualification Name" rules={titleRules} margin="none" />
      <ControlledTagAutocomplete
        name="extra_text"
        margin="none"
        items={tags}
        label="Issuing Body"
        rules={rules}
        setSubstring={setSubstring}
        manualMode={isAdmin}
      />

      <Controller
        control={control}
        name="reference_number"
        render={({ field }) => (
          <AppTextField
            {...field}
            label="Reference number"
            margin="none"
            fullWidth
            error={!!errors.reference_number?.message}
            helperText={(errors.reference_number?.message as string) || ''}
          />
        )}
      />

      <Box display="flex" alignItems="center" gridGap={24}>
        <ControlledDateField
          name="date"
          label="Expiration Date"
          disablePast
          rules={notExpired ? notRequiredRules : rules}
          fullWidth={false}
        />

        <FormControlLabel
          control={
            <AppCheckbox
              color="primary"
              variant="rectangle"
              checked={!!notExpired}
              onChange={handleChange}
            />
          }
          label="Does not expire"
        />
      </Box>
    </>
  );
};
